import moment from "moment";
import { isNaN } from "lodash";
import { onlineT } from "../../typings/online";
import { EnumHelpers } from "../../utils/enum-helpers";
import { Enums } from "../../thor.enums";

class LastModificationService {

    public static $inject: string[] = [
        "$log",
        "$translate"
    ];

    constructor(
        private $log: ng.ILogService,
        private $translate: ng.translate.ITranslateService
    ) {}

    public formattedLapseOfTime(date, parameters) {
        if (!date || isNaN(Date.parse(date))) {
            this.$log.error("No date specified");

            return ;
        }

        this.checkParameters(parameters);

        let wording: string = "modifie";

        if (parameters.type === Enums.ContentTypes.Item) {
            if (parameters.status === Enums.ItemStatus.Confirmed) {
                wording = "publie";
            }

            if (
                parameters.pastItemStatus === onlineT.past.ItemStatus.UNPAID ||
                parameters.pastItemStatus === onlineT.past.ItemStatus.PAID
            ) {
                wording = "adjuge";
            }

            if (parameters.pastItemStatus === onlineT.past.ItemStatus.UNSOLD) {
                wording = "cloture";
            }

            if (parameters.pastItemStatus === onlineT.past.ItemStatus.CANCELED) {
                wording = "retire";
            }
        }

        if (parameters.type === Enums.ContentTypes.Sale) {
            wording = "modifiee";

            if (
                parameters.status === onlineT.future.ContainerStatus.PUBLISHED &&
                parameters.itemModified === false
            ) {
                wording = "publiee";
            }

            if (
                parameters.containerStatus === onlineT.future.ContainerStatus.SCHEDULED &&
                parameters.itemModified === false
            ) {
                wording = "programmee";
            }
        } else if (parameters.type === Enums.ContentTypes.OnlineContainer) {
            wording = "modifie";
        }

        return `${this.$translate.instant(wording)} ${moment(date).fromNow()}`;
    }

    private checkParameters(parameters) {
        const status: string[] = [
            ...EnumHelpers.getValues(Enums.SaleStatus).filter((e: any) => e !== Enums.SaleStatus.Trashed),
            ...EnumHelpers.getValues(Enums.ItemStatus).filter((e: any) => e !== Enums.ItemStatus.Trashed),
            Enums.ItemState.Suppressed
        ];
        const type: string[] = EnumHelpers.getValues(Enums.ContentTypes);
        const containerStatus: string[] = EnumHelpers.getValues(onlineT.future.ContainerStatus);
        const pastItemStatus: string[] = EnumHelpers.getValues(onlineT.past.ItemStatus);
        const errors = [];

        if (!parameters.status) {
            errors.push("No status specified");
        }

        if (!parameters.type) {
            errors.push("No type specified");
        }

        if (status.indexOf(parameters.status) === -1) {
            errors.push(`Invalid parameter: ${parameters.status}. Allowed status' value: ${status.join(", ")}`);
        }

        if (type.indexOf(parameters.type) === -1) {
            errors.push(`Invalid parameter: ${parameters.type}. Allowed type's value: ${type.join(", ")}`);
        }

        if (parameters.containerStatus && containerStatus.indexOf(parameters.containerStatus) === -1) {
            errors.push(
                `Invalid parameter: ${parameters.containerStatus
                    }. Allowed containerStatus' values: ${containerStatus.join(", ")}`
            );
        }

        if (parameters.pastItemStatus && pastItemStatus.indexOf(parameters.pastItemStatus) === -1) {
            errors.push(
                `Invalid parameter: ${parameters.pastItemStatus
                    }. Allowed pastItemStatus' values: ${pastItemStatus.join(", ")}`
            );
        }

        if (errors.length > 0) {
            this.$log.error("Error: LastModificationFilter", errors);

            return ;
        }
    }
}

angular
    .module("thor.core.dates.lastModification.service", [])
    .service("lastModification", LastModificationService);
